export default __webpack_public_path__ + "static/media/overreach6.43e4bce2.png";